/**
 * AI anahtarının metinleri.
 *
 * Bu metinler bir söz veriyor — "yalnızca bu hesabın verisi", "eğitimde
 * kullanılmaz". Söz değişirse davranış da değişmeli; bu yüzden metin tek
 * dosyada ve gözden geçirilebilir duruyor.
 */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const TEXTS: TranslationBundle = {
  en: {
    ai_sw: 'AI', ai_on: 'AI connected', ai_off: 'AI off',
    ai_safe_h: 'Don’t worry. Your information is safe.',
    ai_on_1: 'AI only sees this account’s data. It cannot reach any other account’s records.',
    ai_on_2: 'Your data is never used to train AI models.',
    ai_on_3: 'Analysis results are shown only to you and shared with no one.',
    ai_on_4: 'You can switch it off at any time — analysis stops immediately.',
    ai_off_h: 'AI connection turned off.',
    ai_off_1: 'AI no longer analyses this account’s records.',
    ai_off_2: 'Temporary data held for analysis is not used.',
    ai_off_3: 'You can turn it back on whenever you like.',
    ai_got: 'Got it', ai_save_fail: 'Could not save the setting.',
  },
};
